<section class="container-fluid py-2">
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between gap-3">
        <h1 class="h3 mb-0">{{ title }}</h1>
        <div class="d-flex flex-wrap justify-content-end gap-2">
          <button class="btn btn-outline-success" type="button" (click)="openCreate()">
            <i class="bi bi-plus-lg me-1"></i>Nuevo
          </button>
          <button class="btn btn-outline-warning" type="button" [disabled]="!selectedRecord()" (click)="openSelectedEdit()">
            <i class="bi bi-pencil me-1"></i>Editar
          </button>
          @if (showPasswordAction) {
            <button class="btn btn-outline-secondary" type="button" [disabled]="!selectedRecord()" (click)="openSelectedPasswordModal()">
              <i class="bi bi-key me-1"></i>Contraseña
            </button>
          }
          <button class="btn btn-outline-danger" type="button" [disabled]="!selectedRecord()" (click)="removeSelected()">
            <i class="bi bi-trash me-1"></i>Quitar
          </button>
          @if (supportsAdditionalImages) {
            <button class="btn btn-outline-primary" type="button" [disabled]="!selectedRecord()" (click)="openAdditionalImagesModal()">
              <i class="bi bi-images me-1"></i>Imágenes
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  @if (tableVisible()) {
    <div class="card shadow-sm table-card">
    <div class="card-body">
      <div class="table-responsive">
          <table #dataTable class="table table-hover align-middle w-100">
          <thead>
            <tr>
              @for (field of fields; track field.key) {
                @if (!field.createOnly) {
                  <th>{{ field.label }}</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (record of records(); track record.idRegister) {
              <tr class="selectable-row" [class.table-primary]="selectedRecord()?.idRegister === record.idRegister" (click)="selectRecord(record)">
                @for (field of fields; track field.key) {
                  @if (!field.createOnly) {
                    <td>
                      @if (field.tableDisplay === 'detail') {
                        <button class="btn btn-outline-primary btn-sm" type="button" (click)="$event.stopPropagation(); openDetailModal(record, field)">
                          Consultar
                        </button>
                      } @else if (field.type === 'image') {
                        @if (tableImagePreview(record, field); as imagePreview) {
                          <button class="table-image-button" type="button" (click)="$event.stopPropagation(); openImageModal(imagePreview)">
                            <img class="table-image-preview" [src]="imagePreview" alt="Ver imagen del producto" />
                          </button>
                        } @else {
                          <span class="text-body-secondary">Sin imagen</span>
                        }
                      } @else {
                        {{ value(record, field) }}
                      }
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    </div>
  }
</section>

@if (showFormModal()) {
  <div class="modal d-block" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered" role="document">
      <form class="modal-form" [formGroup]="form" (ngSubmit)="submit()">
        <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title h5 mb-0">{{ editing() ? 'Editar' : 'Nuevo' }} {{ title }}</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeFormModal()"></button>
        </div>
          <div class="modal-body">
            <div class="row">
            @for (field of fields; track field.key) {
              @if (isFieldVisible(field)) {
                <div
                  class="col-12 mb-3"
                  [class.col-md-4]="field.colMd === 4"
                  [class.col-md-6]="field.colMd === 6 || (hasMultipleVisibleFields() && !field.fullWidth && !field.colMd)"
                  [class.col-md-12]="field.colMd === 12"
                >
                  <label class="form-label" [for]="'field-' + field.key">
                    {{ field.label }}@if (field.required !== false) { <span class="text-danger" aria-hidden="true">*</span> }
                  </label>
                  @if (field.relation) {
                    <div class="position-relative">
                      <input
                        class="form-control"
                        [id]="'field-' + field.key"
                        type="search"
                        autocomplete="off"
                        placeholder="Buscar y seleccionar..."
                        [readOnly]="field.readonly"
                        [value]="relationSearch()[field.key] ?? ''"
                        (focus)="openRelationSelector(field)"
                        (input)="updateRelationSearch(field, $any($event.target).value)"
                        (blur)="closeRelationSelector(field)"
                      />
                      @if (activeRelationField() === field.key) {
                        <div class="relation-options border rounded shadow-sm">
                          @for (option of filteredRelationOptions(field); track option.id) {
                            <button class="relation-option btn btn-link text-start w-100" type="button" (mousedown)="$event.preventDefault()" (click)="selectRelation(field, option)">
                              {{ option.label }}
                            </button>
                          } @empty {
                            <span class="d-block px-3 py-2 text-body-secondary">No hay opciones disponibles.</span>
                          }
                        </div>
                      }
                    </div>
                  } @else if (field.type === 'textarea') {
                    <textarea class="form-control" [id]="'field-' + field.key" [attr.rows]="field.rows ?? 3" [formControlName]="field.key"></textarea>
                  } @else if (field.type === 'image') {
                    <input
                      class="visually-hidden"
                      [id]="'field-' + field.key"
                      type="file"
                      [accept]="imageAccept()"
                      (change)="onImageSelected(field, $event)"
                    />
                    <label
                      class="image-drop-zone d-flex flex-column align-items-center justify-content-center text-center p-4"
                      [for]="'field-' + field.key"
                      (dragover)="onImageDragOver($event)"
                      (drop)="onImageDrop(field, $event)"
                    >
                      <i class="bi bi-cloud-arrow-up fs-3 mb-2"></i>
                      <span>Seleccione una imagen o arrástrela y suéltela aquí.</span>
                      <small class="text-body-secondary mt-1">Extensiones permitidas ({{ allowedImageExtensionsLabel() }})</small>
                    </label>
                    @if (imageFileName(field)) {
                      <small class="d-block text-body-secondary mt-2">Archivo: {{ imageFileName(field) }}</small>
                    }
                  } @else {
                    <input
                      class="form-control"
                      [id]="'field-' + field.key"
                      [type]="field.type ?? 'text'"
                      [attr.min]="field.min ?? null"
                      [attr.max]="field.max ?? null"
                      [attr.step]="field.step ?? null"
                      [formControlName]="field.key"
                    />
                  }
                </div>
                @if (field.type === 'image' && imagePreview(field)) {
                  <div class="col-12 mb-3 image-preview-field">
                    <label class="form-label">Vista previa</label>
                    <div class="border rounded p-2 text-center">
                      <img class="img-fluid image-preview" [src]="imagePreview(field)" alt="Vista previa de la imagen seleccionada" />
                    </div>
                  </div>
                }
              }
            }
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" type="button" (click)="closeFormModal()">Cancelar</button>
            <button class="btn btn-primary" type="submit">Guardar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}

@if (showAdditionalImagesModal()) {
  <div class="modal d-block" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title h5 mb-0">Imágenes adicionales</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeAdditionalImagesModal()"></button>
        </div>
        <div class="modal-body">
          <input
            #additionalImagesInput
            class="visually-hidden"
            id="additional-device-images"
            type="file"
            multiple
            [accept]="imageAccept()"
            (change)="onAdditionalImagesSelected($event)"
          />
          <label
            class="image-drop-zone d-flex flex-column align-items-center justify-content-center text-center p-4 mb-3"
            [class.opacity-50]="additionalImagesSaving()"
            for="additional-device-images"
            (dragover)="onImageDragOver($event)"
            (drop)="onAdditionalImagesDrop($event)"
          >
            <i class="bi bi-cloud-arrow-up fs-3 mb-2"></i>
            <span>Seleccione varias imágenes o arrástrelas y suéltelas aquí.</span>
            <small class="text-body-secondary mt-1">Extensiones permitidas ({{ allowedImageExtensionsLabel() }})</small>
          </label>

          <section class="card">
            <div class="card-header">Imágenes asociadas</div>
            <div class="card-body p-0">
              @if (additionalImagesLoading() || additionalImagesSaving()) {
                <p class="text-body-secondary m-3">Cargando imágenes...</p>
              } @else {
                <div class="table-responsive">
                  <table class="table align-middle mb-0 additional-images-table">
                    <thead>
                      <tr>
                        <th>Orden</th>
                        <th>Extensión</th>
                        <th>Imagen</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (image of additionalDeviceImages(); track image.idRegister ?? $index; let index = $index) {
                        <tr>
                          <td>{{ image.fdOrder }}</td>
                          <td>{{ additionalImageExtension(image) }}</td>
                          <td>
                            <img class="additional-image-preview" [src]="additionalImagePreview(image)" alt="Vista previa de imagen adicional" />
                          </td>
                          <td>
                            <div class="d-flex justify-content-center gap-2">
                              <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="additionalImagesSaving() || index === 0" aria-label="Mover hacia arriba" (click)="moveAdditionalImage(index, -1)">
                                <i class="bi bi-arrow-up"></i>
                              </button>
                              <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="additionalImagesSaving() || index === additionalDeviceImages().length - 1" aria-label="Mover hacia abajo" (click)="moveAdditionalImage(index, 1)">
                                <i class="bi bi-arrow-down"></i>
                              </button>
                              <button class="btn btn-outline-danger btn-sm" type="button" [disabled]="additionalImagesSaving()" aria-label="Quitar imagen" (click)="removeAdditionalImage(index)">
                                <i class="bi bi-x-lg"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      } @empty {
                        <tr>
                          <td class="text-body-secondary text-center py-4" colspan="4">No hay imágenes adicionales.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </section>
          <small class="d-block text-body-secondary mt-3">Las imágenes y su orden se guardan inmediatamente.</small>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="closeAdditionalImagesModal()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}

@if (showImageModal()) {
  <div class="modal d-block" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title h5 mb-0">Imagen</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeImageModal()"></button>
        </div>
        <div class="modal-body text-center">
          <img class="modal-image-preview img-fluid" [src]="selectedImage()" alt="Imagen ampliada del producto" />
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="closeImageModal()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}

@if (showDetailModal()) {
  <div class="modal d-block" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title h5 mb-0">{{ detailTitle() }}</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeDetailModal()"></button>
        </div>
        <div class="modal-body">
          <p class="detail-content mb-0">{{ detailContent() }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="closeDetailModal()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}

@if (showPasswordModal()) {
  <div class="modal d-block" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
      <form class="modal-form" [formGroup]="passwordForm" (ngSubmit)="changePassword()">
        <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title h5 mb-0">Cambiar contraseña</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closePasswordModal()"></button>
        </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label" for="password">Contraseña <span class="text-danger" aria-hidden="true">*</span></label>
              <input id="password" class="form-control" type="password" formControlName="password" autocomplete="new-password" />
            </div>
            <div>
              <label class="form-label" for="confirmPassword">Confirmar contraseña <span class="text-danger" aria-hidden="true">*</span></label>
              <input id="confirmPassword" class="form-control" type="password" formControlName="confirmPassword" autocomplete="new-password" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" type="button" (click)="closePasswordModal()">Cancelar</button>
            <button class="btn btn-primary" type="submit">Actualizar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}
